import { useMediaQuery } from '@app/hooks/useMediaQuery';

export enum ScreenWidth {
	widthSM = 768,
	widthXS = 600,
}

export const useIsMobile = (width: ScreenWidth = ScreenWidth.widthSM): boolean => {
	return useMediaQuery(width);
};
